import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';

interface DealCodeModalProps {
    show: boolean;
    onClose: () => void;
    onSubmit: (dealCode: string) => void;
    errorMessage: string | null;
    setErrorMessage: (errorMessage: string | null) => void;
}

const DealCodeModal: React.FC<DealCodeModalProps> = ({ show, onClose, onSubmit, errorMessage, setErrorMessage }) => {
    const [dealCode, setDealCode] = useState("");

    useEffect(() => {
        setErrorMessage(null);
    }, [dealCode]);

    const handleSubmit = () => {
        onSubmit(dealCode.trim());
    };

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <h2>Open Deal Code</h2>
            </Modal.Header>
            <Modal.Body>
                <Alert variant="info">Enter a deal code below to see your file.</Alert>
                <Form className="mt-4">
                    <Form.Group controlId="formDealCode">
                        <Form.Label className="text-dark mb-0">Deal Code</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter deal code..."
                            value={dealCode}
                            onChange={(e) => setDealCode(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Text className="text-danger mt-2">
                        {errorMessage}
                    </Form.Text>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" className="close-button" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    Open
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DealCodeModal;